import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const StructureIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(11);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Structure Icon</title>;
    t1 = <path d="M8 5C8 6.65685 6.65685 8 5 8C3.34315 8 2 6.65685 2 5C2 3.34315 3.34315 2 5 2C6.65685 2 8 3.34315 8 5Z" stroke="currentColor" strokeWidth="1.5" />;
    t2 = <path d="M22 5C22 6.65685 20.6569 8 19 8C17.3431 8 16 6.65685 16 5C16 3.34315 17.3431 2 19 2C20.6569 2 22 3.34315 22 5Z" stroke="currentColor" strokeWidth="1.5" />;
    t3 = <path d="M8 19C8 20.6569 6.65685 22 5 22C3.34315 22 2 20.6569 2 19C2 17.3431 3.34315 16 5 16C6.65685 16 8 17.3431 8 19Z" stroke="currentColor" strokeWidth="1.5" />;
    t4 = <path d="M22 19C22 20.6569 20.6569 22 19 22C17.3431 22 16 20.6569 16 19C16 17.3431 17.3431 16 19 16C20.6569 16 22 17.3431 22 19Z" stroke="currentColor" strokeWidth="1.5" />;
    t5 = <path d="M8 19H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    t6 = <path d="M8 5H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    t7 = <path d="M19 16L19 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    t8 = <path d="M5 16L5 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== props) {
    t9 = <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}</svg>;
    $[9] = props;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
};